import React from 'react';
import classNames from 'classnames';
import LoadingButton from '../../../../../shared/ui/LoadingButton';
import {getDayMonthFromDate} from '../analyticsUtils';
import ReportColumn from './ReportColumn';

export default function DayColumn({
  reportAnalytics,
  phase,
  week,
  day,
  displayedQuestions,
  compact,
  openedDay,
  isApproveReportsLoading,
  popupPosition,
  openDay,
  openApproveReports,
  renderReportsState,
  setPopupPosition,
  getSequenceNumber,
  getLogGroup,
  getBackgroundColor,
  getCellColor,
  getCellValue,
  renderCommentPopup,
  timeConvert,
  enablePtoAnalytics,
}) {
  const reportKey = `${phase.guid}${week.weekNumber}${day}`;
  const reports = reportAnalytics.reportMap[reportKey];

  if (compact) {
    return null
  }

  return (
    <div className={classNames('day', {
      'no-reports': !reports
    })} key={week.numInPhase + day}>
      <div className="day-header">
        {getSequenceNumber(reports, reportKey)}
      </div>

      {!openedDay && <div className="day-header"
           onClick={() => openDay(reportKey, phase.guid, week.weekNumber, day, reports ? reports.length : 0)}>
        <div>{getDayMonthFromDate(day)}</div>
        <div className={'approve-report'}>
          <LoadingButton
            text="Approve reports"
            secondary={true}
            small={true}
            isLoading={isApproveReportsLoading}
            onClick={e => openApproveReports(e, reports) }
          />
          {renderReportsState(reports, phase.guid)}
        </div>
      </div>}

      {reports
        ? <div className="reports">
          {reports.map((report,j) => (
            <ReportColumn
              key={`${reportKey}${j}`}
              report={report}
              reportKey={reportKey}
              displayedQuestions={displayedQuestions}
              openedDay={openedDay}
              popupPosition={popupPosition}
              setPopupPosition={setPopupPosition}
              getLogGroup={getLogGroup}
              getBackgroundColor={getBackgroundColor}
              getCellColor={getCellColor}
              getCellValue={getCellValue}
              renderCommentPopup={renderCommentPopup}
              timeConvert={timeConvert}
            />
          ))}
        </div>
        : (!enablePtoAnalytics ? <div className="reports">
          <div className="report">N/R</div>
        </div>: null)
      }
    </div>
  )
}
